import { GridWidgetService } from '../grid-widget.services';
import { SystemService } from 'common/services/core-services/system.service';
import { MetaModel, WidgetModel } from 'common/models/utility-models/base-model';
import { Injectable } from '@angular/core';
import { ResultReportsDataService } from 'common/services/data-services/admin/reports/result-reports.service';
import { API_URL } from 'common/constants/sm-constants';
import { environment } from 'src/environments/environment';
import { ResultReportsListingModel } from 'common/models/page-models/reports/result-reports/result-report-grid.model';
import { ResultReportsModel } from 'common/models/page-models/reports/result-reports/result-reports-data.model';
import { ResultReportsGridMetaModel } from 'common/models/page-models/reports/result-reports/result-reports-grid-meta.model';


@Injectable({
    providedIn: 'root'
})
export class ResultReportsWidgetService extends GridWidgetService<ResultReportsModel, ResultReportsListingModel> {
    constructor(protected override ds: ResultReportsDataService, protected systemService: SystemService) {
        super(ds);
    }

    getMetaModel(): MetaModel {
        const meta = new ResultReportsGridMetaModel().getMetaModel();
        return meta;
    }

    async getFilterOptions(filterMetaModel: any) {
        // console.log(this.getFilterOptions,"getFilterOptions");
        
        const urlList = [{ url: environment.apiUrl + API_URL.getBatchList, payload: '' }, { url: environment.apiUrl + API_URL.getBranchList, payload: '' }, { url: environment.apiUrl + API_URL.stateList, payload: '' }];
        
        
        await this.ds.apiCallFromMultipleAPIforGrid(urlList).then((data) => {
            // console.log(data,"FILTERRR");

            filterMetaModel.properties.selectedBatch.options = (data[0]).details;
            filterMetaModel.properties.selectedBranch.options = (data[1]).details;
            filterMetaModel.properties.selectedState.options = (data[2]).details;
        })
        
    }

    override prepareMetaModel(dataModel: ResultReportsListingModel, metaModel: ResultReportsGridMetaModel, routeData: WidgetModel): Promise<ResultReportsGridMetaModel> {
        return new Promise<ResultReportsGridMetaModel>((resolve, reject) => {
            resolve(metaModel);
        });
    }

    notifyStudents(ids: any) {
        const payload = {
            reportTypeFlag: 1,
            student_ids: ids
        }
        this.ds.postDataToCustomEndPoint(payload, null, environment.apiUrl + API_URL.notifyStudents).then((data) => {
            this.systemService.showSuccess(data['msg'])
        })
    }

}